import {
  Dialog,
  DialogContent,
  DialogTitle
} from '@material-ui/core';
import React from 'react';
import { t } from '../../commons/Translate.js'

const TaskAssignmentDialog = ({task, open, onClose}) => {
  if (!task) {
    return <></>
  }
  return <Dialog open={open} onClose={onClose}>
    <DialogTitle>{t('Aufgabenstellung für $0', [task.title])}</DialogTitle>
    <DialogContent>
      <div dangerouslySetInnerHTML={{__html: task.assignment}} />
    </DialogContent>
  </Dialog>
}

export default TaskAssignmentDialog